/*
 * Cart drawer cross-sell column.
 *
 * The drawer body is re-rendered server-side on every cart change
 * (GET /cart?view=ajax_side_cart), which dispatches `cart-drawer:rendered`.
 * On that signal this fills the right-hand column from Shopify's own
 * Recommendations API, rendered through the Section Rendering API so the cards
 * stay theme Liquid.
 *
 * Nothing here may depend on Rebuy or any other app: Cookiebot blocks those
 * until the visitor accepts marketing cookies, and the drawer has to work
 * regardless.
 */
(function () {
  'use strict';

  var SECTION_ID = 'cart-drawer-recommendations';
  var LIMIT = 10;

  var column = null;
  var target = null;

  function elements() {
    column = document.querySelector('[data-cart-drawer-crosssell]');
    target = document.querySelector('[data-crosssell-target]');
    return !!(column && target);
  }

  function hideColumn() {
    if (!column) return;
    column.hidden = true;
    if (target) target.innerHTML = '';
  }

  function showColumn(html) {
    if (!column || !target) return;
    target.innerHTML = html;
    column.hidden = false;
  }

  function recommendationsUrl(seedId, intent) {
    return (
      ((window.routes && window.routes.root ? window.routes.root : '') + '/recommendations/products') +
      '?section_id=' + encodeURIComponent(SECTION_ID) +
      '&product_id=' + encodeURIComponent(seedId) +
      '&limit=' + LIMIT +
      '&intent=' + intent
    );
  }

  function fetchIntent(seedId, intent) {
    return fetch(recommendationsUrl(seedId, intent), { headers: { Accept: 'text/html' } })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .catch(function () { return ''; });
  }

  // The section renders nothing when Shopify has no recommendations to give,
  // so an empty card list is the signal to try the next intent.
  function hasCards(html) {
    if (!html) return false;
    return html.indexOf('data-crosssell-card') !== -1;
  }

  // Products already in the cart are not useful cross-sells.
  function dropCartProducts(html, cartProductIds) {
    if (!cartProductIds.length) return html;

    var holder = document.createElement('div');
    holder.innerHTML = html;

    holder.querySelectorAll('[data-crosssell-card]').forEach(function (card) {
      if (cartProductIds.indexOf(card.getAttribute('data-product-id')) !== -1) card.remove();
    });

    return holder.querySelector('[data-crosssell-card]') ? holder.innerHTML : '';
  }

  function render() {
    if (!elements()) return;

    var data = document.querySelector('[data-cart-drawer-data]');
    var seedId = data && data.getAttribute('data-seed-product-id');

    if (!seedId) {
      hideColumn();
      return;
    }

    var cartProductIds = ((data.getAttribute('data-cart-product-ids') || '').split(',')).filter(Boolean);

    // Complementary products are merchandised by hand and are the better
    // suggestion when they exist; related is the algorithmic fallback.
    fetchIntent(seedId, 'complementary')
      .then(function (html) {
        if (hasCards(html)) return html;
        return fetchIntent(seedId, 'related');
      })
      .then(function (html) {
        var cleaned = hasCards(html) ? dropCartProducts(html, cartProductIds) : '';
        if (cleaned) {
          showColumn(cleaned);
        } else {
          hideColumn();
        }
      })
      .catch(hideColumn);
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-loading')) return;

    var original = button.textContent;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (res) { return res.json().then(function (body) { return { ok: res.ok, body: body }; }); })
      .then(function (result) {
        button.classList.remove('is-loading');

        if (!result.ok) {
          button.textContent = (result.body && result.body.description) ? 'Unavailable' : 'Unavailable';
          window.setTimeout(function () { button.textContent = original; }, 2500);
          return;
        }

        // Re-render the drawer body so quantities, subtotal and the cross-sell
        // list all reflect the new cart.
        var refresh = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
        if (typeof refresh === 'function' && window.Shopify && typeof window.Shopify.getCart === 'function') {
          window.Shopify.getCart(function (cart) { refresh(cart); });
        }
      })
      .catch(function () {
        button.classList.remove('is-loading');
        button.textContent = original;
      });
  }

  document.addEventListener('cart-drawer:rendered', render);

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-crosssell-add]');
    if (!button) return;
    event.preventDefault();
    addToCart(button);
  });

  // The drawer body may already be on the page by the time this script runs.
  if (document.querySelector('[data-cart-drawer-data]')) render();
}());
